import { ContentChild, Directive, HostBinding } from '@angular/core';
import { isEmpty } from 'lodash';
import { ButtonToggleLabelDirective } from './button-toggle-label.directive';

@Directive({
    selector: 'mat-button-toggle',
    standalone: false
})
export class ButtonToggleDirective {
  @ContentChild(ButtonToggleLabelDirective) label!: ButtonToggleLabelDirective;

  @HostBinding('class.lui-button-toggle-large') get isLargeClass() {
    return !isEmpty(this.label);
  }
}
